import React from 'react';
import { Box, Button } from '@spothero/ui';
import { RatingDistributionList } from './RatingDistributionList';
import { DriverTagsList } from './DriverTagsList';
import { ReviewsModal } from './ReviewsModal';
import { useReviewsModal } from './hooks/useReviewsModal';
import { useReviewsViewportTracking } from './hooks/useReviewsViewportTracking';
import { NoReviews } from './NoReviews';
import { RatingSummary } from './RatingSummary';
import { normalizeRatingInfo } from './utils/star-utils';
import trackClickedSeeAllReviews from 'segment/events/clicked-see-all-reviews';
export const Reviews = ({ ratingInfo, facilityId, facilityName, }) => {
    const normalizedRating = normalizeRatingInfo(ratingInfo);
    const { numberOfRatings: count, starRating: rating, promptCounts, } = normalizedRating;
    const { isOpen, openModal, closeModal, reviews, isLoading, error, hasMore, sentinelRef, } = useReviewsModal(facilityId || 0);
    const areReviewsVisible = facilityId && count >= 10;
    const displayedRating = rating || 0;
    const { ref: viewportRef } = useReviewsViewportTracking({
        facilityId,
        facilityName,
        starRating: displayedRating,
        count,
    });
    const handleSeeAllReviewsClick = () => {
        if (facilityId && facilityName) {
            trackClickedSeeAllReviews({
                parkingSpotId: facilityId,
                parkingSpotName: facilityName,
                starRating: displayedRating,
                count,
            });
        }
        openModal();
    };
    if (!areReviewsVisible) {
        return <NoReviews />;
    }
    return (<Box data-testid="Reviews" ref={viewportRef}>
            <RatingSummary rating={displayedRating} count={count}/>
            <RatingDistributionList ratingInfo={normalizedRating}/>
            <DriverTagsList prompts={promptCounts}/>
            <Button variant="outline" paddingX={12} marginTop={2} size="base" color="primary.default" onClick={handleSeeAllReviewsClick}>
                See all reviews
            </Button>
            <ReviewsModal isOpen={isOpen} onClose={closeModal} reviews={reviews} isLoading={isLoading} error={error} hasMore={hasMore} sentinelRef={sentinelRef}/>
        </Box>);
};
